export enum ActionTypes {
    FETCH_INSPECTIONS = 'inspections-module/fetch-inspections',
    CREATE_INSPECTION = 'inspections-module/create-inspection',
    UPDATE_INSPECTION = 'inspections-module/update-inspection',
    DELETE_INSPECTION = 'inspections-module/delete-inspection',
    FETCH_INSPECTION = 'inspections-module/fetch-inspection',
    EXECUTE_INSPECTION = 'inspections-module/execute-inspection',
    CANCEL_INSPECTION = 'inspections-module/cancel-inspection',
    FETCH_INSPECTION_SETTINGS = 'inspections-module/fetch-inspection-settings',
    UPDATE_INSPECTION_SETTINGS = 'inspections-module/update-inspection-settings',
}
